module.exports = __webpack_public_path__ + "static/irena-55a0b32104fef2a707d79f62e167ef07.png";